export default __webpack_public_path__ + "static/media/gg.ad37ec63.svg";